"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = exports.LunaGlyphs = exports.LunaIconSizes = exports.LunaIconColors = void 0;

var _lodash = require("lodash");

var _lunaIconManifest = _interopRequireDefault(require("@uitk/luna-icons/dist/sprite/luna-icon-manifest.json"));

var _sizes;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaIconColors = {
  ultramarine95: 'ultramarine-95',
  ultramarine90: 'ultramarine-90',
  ultramarine80: 'ultramarine-80',
  ultramarine70: 'ultramarine-70',
  ultramarine60: 'ultramarine-60',
  ultramarine50: 'ultramarine-50',
  ultramarine40: 'ultramarine-40',
  ultramarine30: 'ultramarine-30',
  ultramarine20: 'ultramarine-20',
  ultramarine10: 'ultramarine-10',
  ultramarine1: 'ultramarine-1',
  green95: 'green-95',
  green90: 'green-90',
  green80: 'green-80',
  green70: 'green-70',
  green60: 'green-60',
  green50: 'green-50',
  green40: 'green-40',
  green30: 'green-30',
  green20: 'green-20',
  green10: 'green-10',
  green1: 'green-1',
  red95: 'red-95',
  red90: 'red-90',
  red80: 'red-80',
  red70: 'red-70',
  red60: 'red-60',
  red50: 'red-50',
  red40: 'red-40',
  red30: 'red-30',
  red20: 'red-20',
  red10: 'red-10',
  red1: 'red-1',
  yellow95: 'yellow-95',
  yellow90: 'yellow-90',
  yellow80: 'yellow-80',
  yellow70: 'yellow-70',
  yellow60: 'yellow-60',
  yellow50: 'yellow-50',
  yellow40: 'yellow-40',
  yellow30: 'yellow-30',
  yellow20: 'yellow-20',
  yellow10: 'yellow-10',
  yellow1: 'yellow-1',
  blue95: 'blue-95',
  blue90: 'blue-90',
  blue80: 'blue-80',
  blue70: 'blue-70',
  blue60: 'blue-60',
  blue50: 'blue-50',
  blue40: 'blue-40',
  blue30: 'blue-30',
  blue20: 'blue-20',
  blue10: 'blue-10',
  blue1: 'blue-1',
  orange95: 'orange-95',
  orange90: 'orange-90',
  orange80: 'orange-80',
  orange70: 'orange-70',
  orange60: 'orange-60',
  orange50: 'orange-50',
  orange40: 'orange-40',
  orange30: 'orange-30',
  orange20: 'orange-20',
  orange10: 'orange-10',
  orange1: 'orange-1',
  purple95: 'purple-95',
  purple90: 'purple-90',
  purple80: 'purple-80',
  purple70: 'purple-70',
  purple60: 'purple-60',
  purple50: 'purple-50',
  purple40: 'purple-40',
  purple30: 'purple-30',
  purple20: 'purple-20',
  purple10: 'purple-10',
  purple1: 'purple-1',
  neutral100: 'neutral-100',
  neutral95: 'neutral-95',
  neutral90: 'neutral-90',
  neutral80: 'neutral-80',
  neutral70: 'neutral-70',
  neutral60: 'neutral-60',
  neutral50: 'neutral-50',
  neutral40: 'neutral-40',
  neutral30: 'neutral-30',
  neutral20: 'neutral-20',
  neutral10: 'neutral-10',
  neutral1: 'neutral-1',
  neutral0: 'neutral-0',
  white: 'white'
};
exports.LunaIconColors = LunaIconColors;
var LunaIconSizes = {
  s10: 'size-10',
  s20: 'size-20',
  s30: 'size-30',
  s40: 'size-40'
};
exports.LunaIconSizes = LunaIconSizes;
var LunaGlyphs = (0, _lodash.reduce)(_lunaIconManifest["default"].collections, function (acc, icons) {
  icons.forEach(function (icon) {
    acc[icon] = icon;
  });
  return acc;
}, {});
exports.LunaGlyphs = LunaGlyphs;
var __baseClass = 'luna-icon';
var classes = {
  base: __baseClass,
  sizes: (_sizes = {}, _defineProperty(_sizes, LunaIconSizes.s10, "".concat(__baseClass, "-").concat(LunaIconSizes.s10)), _defineProperty(_sizes, LunaIconSizes.s20, "".concat(__baseClass, "-").concat(LunaIconSizes.s20)), _defineProperty(_sizes, LunaIconSizes.s30, "".concat(__baseClass, "-").concat(LunaIconSizes.s30)), _defineProperty(_sizes, LunaIconSizes.s40, "".concat(__baseClass, "-").concat(LunaIconSizes.s40)), _sizes),
  colors: _objectSpread({}, (0, _lodash.reduce)(LunaIconColors, function (acc, color) {
    acc[color] = "".concat(__baseClass, "-color-").concat(color);
    return acc;
  }, {}))
};
exports.classes = classes;
